import { useQuery } from 'react-query';

import { UsageStatsRequestDto } from '../../../../../backend/src/usage/dto/usage-stats.request.dto';
import { UsageStatsResponseDto } from '../../../../../backend/src/usage/dto/usage-stats.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

type ActivityStatsFilters = Pick<
  UsageStatsRequestDto,
  'organisationId' | 'matterId' | 'userId' | 'startDate' | 'endDate'
>;

// Org-scoped activity totals (runs, matters, chronologies, doc chronologies, Kim threads),
// narrowed by the matter/user/date filters shared with the activity table.
export const useGetOrgActivityStats = ({ data }: { data: ActivityStatsFilters }) => {
  const { getFetchConfig } = useGetFetchConfig();

  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data,
  });

  return useQuery<UsageStatsResponseDto>(
    [QueryEntity.UsageStats, data.organisationId, data.matterId, data.userId, data.startDate, data.endDate],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/usage/stats`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Network response was not ok from getOrgActivityStats');
      return response.json();
    },
    { refetchOnWindowFocus: false },
  );
};
